<template>
    <div>
        <div class="row">
            <div class="col-lg-3 col-md-6">
                <label class="form-label">{{ _t('Answer') }}</label>
                <input v-model="text" type="text"  class="form-control"/>
            </div>
            <div class="col-lg-3 col-md-6">
                <label for="sortOrder" class="form-label">{{ _t('Sort order') }}</label>
                <input v-model="sortOrder" type="number" id="sortOrder" class="form-control"/>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-md-12" style="margin-top: 16px">
                <button  @click="handleEditAnswer" class="btn btn-success">
                    <span>{{ _t('Save') }}</span>
                </button>
                <button  @click="handleCancel" class="btn btn-secondary">
                    <span>{{ _t('Cancel') }}</span>
                </button>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: "EditAnswer",
    props: [
        'initialText',
        'initialSortOrder',
    ],
    data() {
        return {
            text: this.initialText,
            sortOrder: this.initialSortOrder
        }
    },
    methods: {
        handleEditAnswer() {
            if (!this.text || !this.sortOrder === 0 ) {
                Swal.fire({
                    text: _t('Text and sort order fields are required'),
                    icon: "error",
                    duration: '1000'
                })
                return;
            }

            this.$emit('answer-updated', {
                text: this.text,
                sort_order: this.sortOrder,
            })
        },
        handleCancel() {
            this.reset()
            this.$emit('closed')
        },
        reset() {
            this.text = this.initialText;
            this.sortOrder = this.initialSortOrder;
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/app/components/EditAnswer.vue